<template>
  <div class="intro-box">
    <h6 class="intro-title">基本信息</h6>
    <div style="padding:20px;">
      <h4>项目介绍</h4>
      <ul style="margin-left: 30px;">
        <li style="list-style:disc;">e互助风控系统。</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.intro-box {
	border: 1px solid #ddd;
	border-radius: 4px;
	-webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.intro-title {
	color: #333;
	background-color: #f5f5f5;
	border-color: #ddd;
	padding: 10px;
	border-bottom: 1px solid #ddd;
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
}
</style>
